import Splide from '@splidejs/splide';
import { setupButton } from '/Foundation/Common/code/Views/Foundation/Common/AddToCartButton';

const productlistings = document.querySelectorAll('.product-listing');
let isotopeItems = [];
productlistings.forEach((listing) => {
  isotopeItems = isotopeItems.concat(Array.from(listing.querySelectorAll('.isotope-item')));
});
const productListItems = isotopeItems;
// Must match the hover-image media query in ProductListItem.less, which replaces the slider there.
const hoverImageQuery = window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)');
const splides = new Map();

const syncSlider = (item) => {
  const slider = item.querySelector('.slider-wrapper');
  if (!slider) return;

  const mounted = splides.get(slider);

  if (hoverImageQuery.matches && slider.classList.contains('has-hover-image')) {
    mounted?.destroy();
    splides.delete(slider);
    return;
  }

  if (mounted) {
    mounted.refresh();
    return;
  }

  const slides = parseInt(item.querySelector('.product-list-item')?.dataset.images);
  const splide = new Splide(slider, {
    type: 'slide',
    start: 0,
    arrows: slides > 1,
    pagination: false,
    drag: slides > 1,
    clones: 0,
  });
  splide.mount();
  splides.set(slider, splide);
};

const bindEvents = () => {
  const isDealerBuyersGuideListing = document.getElementById('buyersGuide') != null;
  productListItems.forEach((item) => {
    const slides = parseInt(item.querySelector('.product-list-item')?.dataset.images);
    const arrows = item.querySelector('.splide__arrows');

    if (arrows && slides > 1) {
      item.addEventListener('mouseenter', () => {
        arrows?.classList.remove('d-lg-none');
      });
      item.addEventListener('mouseleave', () => {
        arrows?.classList.add('d-lg-none');
      });
    }

    syncSlider(item);

    if (isDealerBuyersGuideListing) setupButton();
  });
};

const init = () => {
  if (_THULEDATA.IsEditing) {
    return;
  }
  bindEvents();
};

window.addEventListener('changePLPLayout', function () {
  init();
});

hoverImageQuery.addEventListener('change', () => {
  if (_THULEDATA.IsEditing) {
    return;
  }
  productListItems.forEach(syncSlider);
});

document.addEventListener('DOMContentLoaded', function () {
  if (productlistings == null) return;
  init();
});
